import React from 'react'

import _BlockContent from '@sanity/block-content-to-react'

export function BlockContent(props) {
    return <_BlockContent {...props} renderContainerOnSingleChild={true} />
}
